import React from 'react';
import {useSelector} from 'react-redux';

import * as S from './VerificationRequired.styles';
import * as C from '../Common.styles';
import { fullnameSelector } from '../../../../store/selectors';

const VerificationRequired = () => {

    const fullName = useSelector(fullnameSelector);

    return (
        <S.SuccessMsgWrap>
            <S.VerificationHeadText>Verification required</S.VerificationHeadText>
            <S.VerificationInnerWrapper>
                <S.InfoInnerText><strong>Dear {fullName ? fullName : ''},</strong></S.InfoInnerText>
                <S.InfoInnerText>Congratulations on registering with myPartner!</S.InfoInnerText>
                <S.InfoInnerTextWrap>Our support team will contact you on your registered phone number for document verification within 24 hours.</S.InfoInnerTextWrap>
            </S.VerificationInnerWrapper>
        </S.SuccessMsgWrap>
    );
}

export default VerificationRequired;